import React, { useEffect, useRef, useState } from 'react';
import styles from './CineControls.module.css';

export default function CineControls({ total, activeIndex, onSelect, onToggleKey, isKey }) {
  const [playing, setPlaying] = useState(false);
  const [fps, setFps] = useState(8);
  const timer = useRef(null);

  useEffect(() => {
    if (!playing || total <= 1) return;
    timer.current = setInterval(() => {
      onSelect?.((activeIndex + 1) % total);
    }, 1000 / Math.max(1, fps));
    return () => { clearInterval(timer.current); timer.current = null; };
  }, [playing, fps, activeIndex, total, onSelect]);

  if (total <= 1) return null;

  return (
    <div className={styles.bar}>
      <button className={styles.btn} onClick={() => onSelect?.(0)}          title="First">⏮</button>
      <button className={styles.btn} onClick={() => onSelect?.(Math.max(0, activeIndex - 1))} title="Previous">◀</button>
      <button className={`${styles.btn} ${playing ? styles.active : ''}`} onClick={() => setPlaying(p => !p)} title="Play / Pause">
        {playing ? '⏸' : '▶'}
      </button>
      <button className={styles.btn} onClick={() => onSelect?.(Math.min(total - 1, activeIndex + 1))} title="Next">▶</button>
      <button className={styles.btn} onClick={() => onSelect?.(total - 1)}  title="Last">⏭</button>
      <button className={`${styles.btn} ${isKey ? styles.star : ''}`} onClick={onToggleKey} title="Key image (K)">★</button>
      <span className={styles.fps}>
        <input type="range" min="1" max="30" value={fps} onChange={(e) => setFps(Number(e.target.value))} />
        <span className={styles.fpsLabel}>{fps} fps</span>
      </span>
      <span className={styles.pos}>{activeIndex + 1} / {total}</span>
    </div>
  );
}
